module.exports = __webpack_public_path__ + "img/premiation-8-viagem-argentina.d7ea7edc.png";